// extracted by mini-css-extract-plugin
module.exports = {"sliderItem":"AFcl","ready":"AFcn"};